import { render, staticRenderFns } from "./PopupStreak.vue?vue&type=template&id=3aae1094&scoped=true&"
import script from "./PopupStreak.vue?vue&type=script&lang=js&"
export * from "./PopupStreak.vue?vue&type=script&lang=js&"
import style0 from "./PopupStreak.vue?vue&type=style&index=0&id=3aae1094&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aae1094",
  null
  
)

export default component.exports